export default {
  common: {
    loading: '載入中...',
    save: '儲存',
    saving: '儲存中...',
    cancel: '取消',
    delete: '刪除',
    edit: '編輯',
    create: '建立',
    confirm: '確認',
    back: '返回',
    next: '下一步',
    submit: '提交',
    search: '搜尋',
    noData: '沒有資料',
    error: '發生錯誤',
    success: '操作成功',
    offline: '您已離線',
    online: '已恢復連線'
  },
  auth: {
    login: {
      title: '歡迎回來',
      subtitle: '登入以繼續使用 Maid Mate',
      submit: '登入'
    },
    register: {
      title: '建立帳戶',
      subtitle: '立即加入 Maid Mate',
      submit: '建立帳戶'
    },
    email: '電子郵件',
    emailPlaceholder: '輸入您的電子郵件',
    password: '密碼',
    passwordPlaceholder: '輸入您的密碼',
    confirmPassword: '確認密碼',
    forgotPassword: '忘記密碼？',
    noAccount: '還沒有帳戶？',
    hasAccount: '已經有帳戶？',
    orContinueWith: '或繼續使用',
    agreeTerms: '我同意服務條款和隱私政策',
    passwordStrength: {
      weak: '弱',
      medium: '中等',
      strong: '強'
    }
  },
  validation: {
    required: '此欄位為必填',
    invalidEmail: '請輸入有效的電子郵件地址',
    passwordMinLength: '密碼至少需要8個字元',
    passwordMismatch: '密碼不符'
  },
  tasks: {
    title: '任務',
    createTask: '建立任務',
    taskDetails: '任務詳情',
    pending: '待執行',
    inProgress: '進行中',
    finished: '已完成',
    completed: '已確認',
    cancelled: '已取消',
    startTask: '開始任務',
    finishTask: '完成任務',
    completeTask: '確認完成',
    cancelTask: '取消任務',
    rateTask: '評分任務',
    taskTitle: '標題',
    taskNotes: '備註',
    dueDate: '截止日期',
    assignedTo: '指派給',
    noTasks: '沒有任務',
    proofImages: '證明圖片',
    addProofImage: '新增證明圖片'
  },
  expenses: {
    title: '支出',
    createExpense: '記錄支出',
    expenseDetails: '支出詳情',
    amount: '金額',
    currency: '貨幣',
    category: '分類',
    description: '描述',
    date: '日期',
    receipt: '收據',
    pending: '待驗證',
    verified: '已驗證',
    verify: '驗證',
    reports: '報表',
    totalAmount: '總金額',
    byCategory: '按分類',
    noExpenses: '沒有支出記錄',
    from: '從',
    to: '到'
  },
  quotations: {
    title: '報價單',
    createQuotation: '建立報價單',
    quotationDetails: '報價單詳情',
    draft: '草稿',
    submitted: '已提交',
    approved: '已批准',
    rejected: '已拒絕',
    submit: '提交審批',
    approve: '批准',
    reject: '拒絕',
    complete: '標記完成',
    rejectionReason: '拒絕原因',
    noQuotations: '沒有報價單',
    vendorName: '供應商名稱',
    validUntil: '有效期至',
    imageUrl: '圖片網址'
  },
  mealplans: {
    title: '餐計劃',
    createMealPlan: '建立餐計劃',
    mealPlanDetails: '餐計劃詳情',
    day: '日',
    week: '週',
    startDate: '開始日期',
    endDate: '結束日期',
    breakfast: '早餐',
    lunch: '午餐',
    dinner: '晚餐',
    snack: '點心',
    getRecommendation: '獲取 AI 推薦',
    noMealPlans: '沒有餐計劃'
  },
  favor: {
    title: '飲食偏好',
    allergies: '過敏食物',
    dietaryRestrictions: '飲食限制',
    preferences: '食物偏好',
    addAllergy: '新增過敏',
    addRestriction: '新增限制',
    addPreference: '新增偏好'
  },
  household: {
    title: '家庭',
    profile: '家庭資料',
    name: '家庭名稱',
    createHousehold: '建立家庭',
    joinHousehold: '加入家庭',
    householdName: '家庭名稱',
    notes: '備註',
    members: '成員',
    memberHistory: '成員歷史',
    qrCode: 'QR Code',
    scanQR: '掃描 QR Code',
    leaveHousehold: '離開家庭',
    deleteHousehold: '刪除家庭',
    selectHousehold: '選擇家庭',
    noHouseholds: '沒有家庭',
    noHousehold: '尚未選擇家庭',
    create: '建立家庭',
    createdAt: '建立時間',
    joinLink: '加入連結',
    joinLinkDesc: '分享此連結邀請成員加入您的家庭。',
    generateLink: '產生加入連結',
    linkExpires: '到期時間',
    dangerZone: '危險區域',
    dangerZoneDesc: '刪除家庭將移除所有資料和成員。',
    deleteConfirmTitle: '確定刪除家庭？',
    deleteConfirmDesc: '此操作無法復原。所有任務、費用和資料將被永久刪除。',
    deleteConfirm: '刪除',
    removeMemberConfirm: '確定要從家庭中移除 {name} 嗎？'
  },
  profile: {
    title: '個人資料',
    displayName: '顯示名稱',
    email: '電子郵件',
    role: '角色',
    settings: '設定',
    notifications: '通知',
    syncStatus: '同步狀態',
    auditLog: '審計日誌',
    logout: '登出',
    deleteAccount: '刪除帳戶',
    biometric: '生物識別登入'
  },
  notifications: {
    title: '通知',
    markAllRead: '全部標為已讀',
    noNotifications: '沒有通知'
  },
  sync: {
    title: '同步狀態',
    online: '線上',
    offline: '離線',
    syncing: '同步中...',
    lastSync: '最後同步',
    pending: '待同步操作',
    failed: '失敗操作',
    retry: '重試失敗',
    clearCompleted: '清除已完成'
  }
}
